import React from 'react';
import { motion } from 'framer-motion';
type SectionProps = {
  children: React.ReactNode;
  tone?: 'cream' | 'white' | 'navy';
  className?: string;
  id?: string;
};
export function Section({
  children,
  tone = 'cream',
  className = '',
  id
}: SectionProps) {
  const toneClass = tone === 'navy' ? 'bg-navy-deep text-white' : tone === 'white' ? 'bg-white text-navy' : 'bg-cream text-navy';
  return <section id={id} className={`w-full ${toneClass} ${className}`} data-id="element-248" data-mp="1dkjz8xlylvyl">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-3xl px-5 py-12 sm:py-16" data-id="element-249" data-mp="18lp4cxapwgy4">
        {children}
      </motion.div>
    </section>;
}
type SectionTitleProps = {
  children: React.ReactNode;
  eyebrow?: string;
  tone?: 'light' | 'dark';
  className?: string;
};
export function SectionTitle({
  children,
  eyebrow,
  tone = 'light',
  className = ''
}: SectionTitleProps) {
  return <div className={`text-center ${className}`} data-id="element-250" data-mp="2ek6aja9xp3p3">
      {eyebrow ? <p className={`mb-3 text-[11px] font-bold uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-gold' : 'text-gold-dark'}`} data-id="element-251" data-mp="2ejecztws0vw6">
          {eyebrow}
        </p> : null}
      <h2 className={`font-display text-[1.7rem] font-bold leading-[1.15] tracking-tight sm:text-4xl ${tone === 'dark' ? 'text-white' : 'text-navy'}`} data-id="element-252" data-mp="24s09lb1pfbxr">
        {children}
      </h2>
    </div>;
}